<template>
  <div class="ip-project-wrap">
    <div class="title-wrap infos1">
      <TitleCard title="金融产品与服务" :loading="loading1" :isEmpty="isEmpty1" :moreText="financialText" @moreClick="showMoreIps">
        <div class="infos-wrap">
          <div class="project-card" v-for="(item) in resultList2" :key="item.id">
            <MediaWrap class="audio-wrap" :url="item.picture" :width="224" :height="250"></MediaWrap>
            <div class="title">{{item.title}}</div>
            <a-button @click="toDetail(item.id)">查看详情</a-button>
          </div> 
        </div>
      </TitleCard>
    </div>
    <div class="title-wrap ips-mid-wrap" v-show="!isIpsMore">
      <TitleCard title="质押融资服务联盟" :showMore="false">
        <div class="mid-wrap">
          <div class="side-warp">
            <div class="item-wrap">
              <div class="tip-item title">金融机构/商业银行</div>
              <div class="tip-item">中国银行、建设银行、农业银行、工商银行、 知信贷、知能贷、知我贷。</div>
            </div>
            <div class="item-wrap">
              <div class="tip-item title">担保公司</div>
              <div class="tip-item">三一融资担保公司、开发区小担保、一龙融资担保</div>
            </div>
          </div>
          <div class="mid-img-wrap">
            <img src="/static/ips_mid_pg.png" alt="">
          </div>
          <div class="side-warp right">
            <div class="item-wrap">
              <div class="tip-item title">政府、财政基金</div>
              <div class="tip-item">基金由市财政统筹中央及省、市资金安排，首期规模人民币XXX万无。XX服务公司作为基金管理人负责日常管理。</div>
            </div>
            <div class="item-wrap">
              <div class="tip-item title">保险公司</div>
              <div class="tip-item">太平洋保险、 中国人寿、 中国平安</div>
            </div>
          </div>
        </div>
      </TitleCard>
    </div>
    <div class="title-wrap bottom-wrap" v-show="!isIpsMore">
      <TitleCard title="质押融资基本模式" :showMore="false">
        <div class="mode-tips-wrap">
          <img src="/static/mode_tips.png" alt="">
          <div class="itemMain item1" @mousemove="mouseOver(1)" @mouseleave="mouseLeave(1)">
            <div class="p">
              <div class="fake-wrap fake-wrap1" v-show="item1">企业经营过程中，遇到资金困难或为拥有的专利进行投保等需求，针对相应金融产品向平台提出申请</div>
            </div>
          </div>
          <div class="itemMain item2" @mousemove="mouseOver(2)" @mouseleave="mouseLeave(2)">
            <div class="p">
              <div class="fake-wrap fake-wrap2" v-show="item2">平台受理申请人提交的金融产品或服务申请</div>
            </div>
          </div>
          <div class="itemMain item3" @mousemove="mouseOver(3)" @mouseleave="mouseLeave(3)">
            <div class="p">
              <div class="fake-wrap fake-wrap3" v-show="item3">平台受理申请人的申请后，根据申请人提交的基本材料，进行申请人资格审查和知识产权初步评价分析</div>
            </div>
          </div>
          <div class="itemMain item4" @mousemove="mouseOver(4)" @mouseleave="mouseLeave(4)">
            <div class="p">
              <div class="fake-wrap fake-wrap4" v-show="item4">平台联合金融机构、第三方评价机构对申请人进行相关联合考察和以知识产权为重点的尽职调查</div>
            </div>
          </div>
          <div class="itemMain item5" @mousemove="mouseOver(5)" @mouseleave="mouseLeave(5)">
            <div class="p">
              <div class="fake-wrap fake-wrap5" v-show="item5">平台根据尽调结果，满足相关条件的，向机构提交材料进入机构审批程序</div>
            </div>
          </div>
          <div class="itemMain item6" @mousemove="mouseOver(6)" @mouseleave="mouseLeave(6)">
            <div class="p">
              <div class="fake-wrap fake-wrap6" v-show="item6">审批通过，申请人、机构与平台签订双方或三方协议</div>
            </div>
          </div>
          <div class="itemMain item7" @mousemove="mouseOver(7)" @mouseleave="mouseLeave(7)">
            <div class="p">
              <div class="fake-wrap fake-wrap7" v-show="item7">机构审批完成，根据申请人选择的金融产品，实施资金划转、专利保险等具体业务</div>
            </div>
          </div>
        </div>
      </TitleCard>
    </div>
  </div>
</template>

<script>
import { ipProjectData } from './data'
import { getIpProject } from '@/api/IpProject.js'

export default {
  data() {
    return {
      financialText: '更多',
      ipProjectData,
      resultList: [],
      resultList2: [],
      isIpsMore: false,
      ipData: [],
      loading1: false,
      isEmpty1: false,
      item1: false,
      item2: false,
      item3: false,
      item4: false,
      item5: false,
      item6: false,
      item7: false
    }
  },
  components: {
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.loading1 = true
        const { rows } = await getIpProject()
        rows.forEach(item => {
          const {fileVo} = item
          
          if(fileVo && fileVo.length > 0){
            const picture = fileVo[0].filePath
            // console.log(picture);
            item.picture = picture
          }else{
            item.picture = ''
          }
        })
        this.resultList = rows
        this.resultList2 = JSON.parse(JSON.stringify(this.resultList)).slice(0,5)
      } catch (error) {
        console.log(error, '金融产品与服务')
      } finally {
        this.loading1 = false
      }
    },
    showMoreIps(status) {
      if(status){
        this.resultList2 = this.resultList
        this.financialText = '返回'
      }else{
        this.resultList2 = JSON.parse(JSON.stringify(this.resultList)).slice(0,5)
        this.financialText = '更多'
      }
      this.isIpsMore = status
    },
    mouseOver(idx) {
      this[`item${idx}`] = true
    },
    mouseLeave(idx) {
      this[`item${idx}`] = false
    },
    toDetail(id) {
      this.$router.push(`/ipFinancialProducts/detail?${id}`)
    }
  }
}
</script>
